import { useEffect, useState } from "react";
import DocumentGateway from "../../api/gateways/DocumentGateway";

export const useFilePreview = (url: string) => {
  const [localUrl, setLocalUrl] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      setLocalUrl(undefined);
      setLoading(false);
      return;
    }

    // If URL is already a blob URL, just use it directly
    if (url.startsWith("blob:")) {
      setLocalUrl(url);
      setLoading(false);
      return;
    }

    // Otherwise fetch file from backend and create blob URL
    setLoading(true);
    let isActive = true;

    DocumentGateway.getDocumentFile(url)
      .then((fileBlob) => {
        if (!isActive) return;
        const objectUrl = URL.createObjectURL(fileBlob);
        setLocalUrl(objectUrl);
      })
      .catch(() => {
        if (!isActive) return;
        setLocalUrl(undefined);
      })
      .finally(() => {
        if (!isActive) return;
        setLoading(false);
      });

    return () => {
      isActive = false;
      if (localUrl && localUrl.startsWith("blob:")) {
        URL.revokeObjectURL(localUrl);
      }
    };
  }, [url]);

  return { loading, url: localUrl };
};
